import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigatorOnLine} from '../../../../hooks/UseNavigatorOnline';
import ErrorModalWrapper from '../../../../incase-domain/components/modals/errorModal/ErrorModalWrapper';
import ErrorModalContent from '../../../../incase-domain/components/modals/errorModal/ErrorModalContent';
import {SvgSpinners6DotsScale} from '../../../../incase-domain/components/SvgSpinners6DotsScale';

function OfflineModal(): JSX.Element | null {
    const {t} = useTranslation();
    const isOnline = useNavigatorOnLine();
    const [offlineModal, setOfflineModal] = useState<boolean>(false);

    useEffect(() => {
        if (!isOnline) setOfflineModal(true);
    }, [isOnline]);

    if (isOnline) return null;

    return (
        <ErrorModalWrapper isOpen={offlineModal}>
            <SvgSpinners6DotsScale fontSize="10rem" color="#f14668" />
            <ErrorModalContent title={t('modals.offline.header')} description={t('modals.offline.content')} />
        </ErrorModalWrapper>
    );
}

export default OfflineModal;
